import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from '../constants/constants';
import { BaseConocimientoDto } from '../dto/justino/base-conocimiento.dto';
import { environment } from '../../environments/environment';
import { UtilService } from './util.service';

@Injectable({
  providedIn: 'root'
})
export class BaseConocimientoService {

  private apiUrl = `${environment.justinoApiUrl}/api/bases-conocimiento/`;

  constructor(
    private http: HttpClient) {}

  getHeaders() {
    const authToken = sessionStorage.getItem(Constants.ACCESS_TOKEN) ?? ''; 
    return { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`,
    };
  }

  getBasesConocimiento(): Observable<BaseConocimientoDto[]> {
    return this.http.get<BaseConocimientoDto[]>(this.apiUrl, { headers: this.getHeaders() });
  }

  getBaseConocimientoById(id: string): Observable<BaseConocimientoDto> {
    return this.http.get<BaseConocimientoDto>(`${this.apiUrl}${id}`, { headers: this.getHeaders() });
  }

  createBaseConocimiento(baseConocimiento: BaseConocimientoDto): Observable<BaseConocimientoDto> {
    return this.http.post<BaseConocimientoDto>(this.apiUrl, baseConocimiento, { headers: this.getHeaders() });
  }

  updateBaseConocimiento(id: string, baseConocimiento: BaseConocimientoDto): Observable<BaseConocimientoDto> {
    return this.http.put<BaseConocimientoDto>(`${this.apiUrl}${id}`, baseConocimiento, { headers: this.getHeaders() });
  }

  deleteBaseConocimiento(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}${id}`, { headers: this.getHeaders() });
  }
}
